const daytype = {
    namespaced: true,
    state: {
        dayTypeList: [],
        dayTypes: []
    },
    mutations: {
        updateDayTypeList(state, newList) {
            state.dayTypeList = newList;
        },
        updateDayTypes(state, newList) {
            state.dayTypes = newList;
        }
    },
    actions: {
        getDayTypeList(context) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/daytype/getDayTypes')
                    .then(response => {
                        if (response.status == 200) {
                            context.commit('updateDayTypeList', response.data);
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        },
        addDayType(context, newDayType) {
            context.dispatch('saveDayType', { method: 'addDayType', json: newDayType });
        },
        editDayType(context, newDayType) {
            context.dispatch('saveDayType', { method: 'editDayType', json: newDayType });
        },
        saveDayType(context, params) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/daytype/'+ params.method, params.json)
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getDayTypeList');
                            resolve(response);
                        } else {
                            reject();
                        }
                    })
                    .catch(error => {
                        reject(error);
                    })
            });
        },
        getDayTypesWithCalendars(context) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/daytype/getDayTypesWithCalendars')
                    .then(response => {
                        if (response.status == 200) {
                            context.commit('updateDayTypes', response.data);
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        },
        addDayTypeWithCalendars(context, newDayType) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/daytype/addDayTypeWithCalendars', newDayType)
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getDayTypesWithCalendars');
                            resolve(response);
                        } else {
                            reject();
                        }
                    })
                    .catch(error => {
                        reject(error);
                    })
            });
        },
        editDayTypeWithCalendars(context, newDayType) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/daytype/editDayTypeWithCalendars', newDayType)
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getDayTypesWithCalendars');
                            resolve(response);
                        } else {
                            reject();
                        }
                    })
                    .catch(error => {
                        reject(error);
                    })
            });
        },
        deleteDayType(context, dayTypeId) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/daytype/deleteDayType', { params: { "id": dayTypeId } })
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getDayTypesWithCalendars');
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        }
    }
}

export default daytype;